import { createContext, useContext, useState, useEffect, useCallback } from "react";

const BoardContext = createContext(null);
export const useBoard = () => useContext(BoardContext);

const KEY = "cg_board";

export function BoardProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const has = useCallback((id) => items.some((i) => i.id === id), [items]);

  const toggle = useCallback((item) => {
    setItems((prev) => (prev.some((i) => i.id === item.id) ? prev.filter((i) => i.id !== item.id) : [...prev, item]));
  }, []);

  const remove = useCallback((id) => setItems((prev) => prev.filter((i) => i.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  return (
    <BoardContext.Provider value={{ items, has, toggle, remove, clear, count: items.length }}>
      {children}
    </BoardContext.Provider>
  );
}
